module.exports = __webpack_public_path__ + "static/media/pinterest.d186068e.png";